export default __webpack_public_path__ + "static/bottle-42570b85031eade1c1cd825aa0834a74.png";